import React from 'react';

const RehearsalSchedule = () => {
  const schedule = {
    headers: ['Time', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    rows: [
      {
        time: '10:00 - 11:30 AM',
        activities: ['Company Class', 'Company Class', 'Company Class', 'Company Class', 'Company Class', 'Company Class']
      },
      {
        time: '11:45 AM - 1:15 PM',
        activities: ['Swan Lake, Act II', 'Don Quixote Pas de Deux', 'Swan Lake, Act II', 'Contemporary Workshop', 'Swan Lake, Full Cast', 'Run-through: Swan Lake']
      },
      {
        time: '1:15 - 2:15 PM',
        activities: ['Lunch Break', 'Lunch Break', 'Lunch Break', 'Lunch Break', 'Lunch Break', 'Lunch Break']
      },
      {
        time: '2:15 - 4:00 PM',
        activities: ['New Work by Guest Choreographer', 'Soloist Coaching', 'New Work by Guest Choreographer', 'The Nutcracker, Act I', 'Corps de Ballet Sectionals', 'Notes & Corrections']
      },
      {
        time: '4:15 - 5:30 PM',
        activities: ['The Nutcracker, Act I', 'Pointe Technique', 'Don Quixote, Group Dances', 'New Work by Guest Choreographer', 'The Nutcracker, Full Cast', 'End of Day']
      }
    ]
  };

  return (
    <div className="container-custom py-12">
      <h1 className="text-4xl font-bold font-elegant text-ballet-burgundy mb-4 text-center">Company Rehearsal Schedule</h1>
      <p className="text-lg text-gray-700 mb-12 text-center max-w-3xl mx-auto">
        The following is a sample weekly rehearsal schedule for the Northwest Ballet Theater company artists. Please note that schedules are subject to change based on performance needs and casting.
      </p>
      <div className="bg-white rounded-lg shadow-elegant overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-ballet-light-pink">
              <tr>
                {schedule.headers.map(header => (
                  <th key={header} scope="col" className="px-6 py-3 text-left text-xs font-medium text-ballet-burgundy uppercase tracking-wider">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {schedule.rows.map((row, rowIndex) => (
                <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{row.time}</td>
                  {row.activities.map((activity, activityIndex) => (
                    <td key={activityIndex} className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                      {activity}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
       <p className="text-sm text-gray-600 mt-8 text-center">
        All rehearsals are closed to the public unless otherwise specified. For information on open rehearsals or studio viewings, please check the News Room or contact us directly.
      </p>
    </div>
  );
};

export default RehearsalSchedule;
